import {
  DropdownMenuContent,
  DropdownMenuItem,
} from "@/components/ui/dropdown-menu";

import { VariableConfig } from "./VariableNode";

interface VariableDropdownProps {
  variables: VariableConfig;
  onSelect: (variableName: string) => void;
  currentVariable?: string;
}

export function VariableDropdown({
  variables,
  onSelect,
  currentVariable,
}: VariableDropdownProps) {
  return (
    <DropdownMenuContent align="start" className="min-w-[200px]">
      {Object.entries(variables).map(([key, value]) => (
        <DropdownMenuItem
          key={key}
          onClick={() => onSelect(key)}
          className={`cursor-pointer ${
            key === currentVariable ? "bg-gray-100" : ""
          }`}
        >
          <div className="flex w-full justify-between items-center gap-2">
            <span className="font-medium">{value}</span>
            <span className="text-xs text-gray-500">{`{{${key}}}`}</span>
          </div>
        </DropdownMenuItem>
      ))}
    </DropdownMenuContent>
  );
}
